module.exports = __webpack_public_path__ + "img/estacionamento.6b9d83d3.svg";